import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").trim();

export const API = BACKEND_URL
  ? `${BACKEND_URL.replace(/\/$/, "")}/api`
  : "/api";

export const apiFileUrl = (fileId) => `${API}/files/${encodeURIComponent(fileId)}`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = String(error?.config?.url || "");
    const isAuthRoute =
      url.includes("/auth/login") ||
      url.includes("/auth/register") ||
      url.includes("/auth/logout") ||
      url.includes("/auth/me");
    if (status === 401 && !isAuthRoute) {
      if (typeof window !== "undefined") {
        const currentPath = window.location.pathname + window.location.search;
        const onLoginPage = window.location.pathname === "/login";
        if (!onLoginPage) {
          const next = encodeURIComponent(currentPath);
          window.location.assign(`/login?next=${next}`);
        }
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) {
    return "Something went wrong. Please try again.";
  }

  if (typeof detail === "string") {
    return detail;
  }

  if (Array.isArray(detail)) {
    return detail
      .map((item) =>
        item && typeof item.msg === "string"
          ? item.msg
          : JSON.stringify(item)
      )
      .filter(Boolean)
      .join(", ");
  }

  if (detail && typeof detail.msg === "string") {
    return detail.msg;
  }

  if (detail && typeof detail.message === "string") {
    return detail.message;
  }

  return String(detail);
}
